/**
 * Collects device/session signals that are available client-side without any
 * additional permission prompts. Sent to the server on sign-in to build the
 * participant's last-known device snapshot.
 */
export function collectDeviceInfo() {
  let notificationPermission = 'unsupported'
  if (typeof Notification !== 'undefined') {
    notificationPermission = Notification.permission || 'default'
  }

  const isPwaStandalone =
    (typeof window !== 'undefined' &&
      (window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone)) ||
    false

  let timezone = null
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null
  } catch (e) {
    timezone = null
  }

  return {
    timezone,
    notificationPermission,
    isPwaStandalone
  }
}
